import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field } from 'redux-form';

import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import Link from 'components/common/Link';
import IconButton from 'components/common/IconButton';
import IconPlus from 'components/icons/IconPlus';
import IconCross from 'components/icons/IconCross';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    marginTop: 10,
  },
  fieldArrayLabel: {
    position: 'relative',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
  fieldContainder: {
    marginTop: 10,
    position: 'relative',
    padding: 16,
    border: `1px dashed ${theme.palette.grey[600]}`,
    borderRadius: 4,
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 24,
      height: 25,
      backgroundColor: theme.palette.common.white,
      top: -4,
      right: -12,
      zIndex: 1,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 8,
      marginRight: 24,
    },
  },
  fieldIndex: {
    top: -4,
    left: -12,
    position: 'absolute',
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    padding: '4px 0',
    width: 24,
    textAlign: 'center',
    fontWeight: 700,
    color: theme.palette.primary[500],
    backgroundColor: theme.palette.common.white,
    transform: 'none',
  },
  iconPlus: {
    width: 14,
    height: 14,
    marginBottom: -2,
    marginRight: 8,
  },
  buttonAddDay: {
    // margin: '16px 0 0 0',
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  buttonDelete: {
    position: 'absolute',
    right: -24,
    top: -16,
    zIndex: 10,
  },
});

const PayerContactFieldArray = ({
  fields,
  variant,
  classes,
}) => {
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={16}
        alignItems="center"
        justify="flex-start"
      >
        {fields.length > 0 && (
          <Grid item>
            <Typography className={classes.fieldArrayLabel}>
              {variant === 'phone' && 'Phone '}
              {variant === 'fax' && 'Fax '}
              {variant === 'email' && 'Email '}
              Contacts
            </Typography>
          </Grid>
        )}
        <Grid item>
          <Link
            className={classes.buttonAddDay}
            color="primary"
            size="md"
            bold
            onClick={() => {
              fields.push({});
            }}
          >
            <IconPlus className={classes.iconPlus} />
            Add
            {(fields.length === 0 && variant === 'phone') && ' Phone'}
            {(fields.length === 0 && variant === 'fax') && ' Fax'}
            {(fields.length === 0 && variant === 'email') && ' Email'}
          </Link>
        </Grid>
      </Grid>
      {fields.map((field, index) => (
        <div className={classes.fieldContainder} key={field}>
          <Typography className={classes.fieldIndex}>
            {index + 1}
          </Typography>
          <IconButton
            className={classes.buttonDelete}
            onClick={() => {
              fields.remove(index);
            }}
            tooltipContent="Delete Contact"
          >
            <IconCross className={classes.iconCross} />
          </IconButton>
          <Grid
            container
            spacing={16}
            alignItems="flex-end"
            justify="space-between"
          >
            <Grid
              item
              xs={5}
            >
              {(variant === 'phone' || variant === 'fax') && (
                <Field
                  id={`${field}.Value`}
                  name={`${field}.Value`}
                  placeholder={variant === 'phone' ? 'Phone' : 'Fax'}
                  component={TextField}
                  validate={[validate.phone]}
                  format={value => (value ? value.replace('+1 ', '') : '')}
                  normalize={normalize.phone}
                  maxLength="14"
                  errorPlacement="bottom"
                  startAdornment={
                    <InputAdornment position="start">
                      <TextFieldAdornmentText>
                        +1
                      </TextFieldAdornmentText>
                    </InputAdornment>
                  }
                  fullWidth
                />
              )}
              {variant === 'email' && (
                <Field
                  id={`${field}.Value`}
                  name={`${field}.Value`}
                  placeholder="Email"
                  component={TextField}
                  validate={[validate.email]}
                  errorPlacement="top"
                  fullWidth
                />
              )}
            </Grid>
            <Grid item xs={7}>
              <Field
                id={`${field}.Description`}
                name={`${field}.Description`}
                placeholder="Description"
                component={TextField}
                errorPlacement="bottom"
                fullWidth
              />
            </Grid>
          </Grid>
        </div>
      ))}
    </div>
  );
};

PayerContactFieldArray.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PayerContactFieldArray);



// WEBPACK FOOTER //
// ./src/components/settings/PayerCreateEditDialog/PayerContactFieldArray.js